import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Guide18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M4.50006 10.5607L7.53039 7.53032L6.46973 6.46966L4.50006 8.43933L3.53039 7.46966L2.46973 8.53032L4.50006 10.5607Z'
      fill='currentColor'
    />
    <path
      d='M15.1818 7.2276C15.5837 7.12714 15.828 6.71994 15.7275 6.31809C15.6271 5.91624 15.2199 5.67192 14.818 5.77238L10.818 6.77238C10.4162 6.87285 10.1719 7.28005 10.2723 7.68189C10.3728 8.08374 10.78 8.32806 11.1818 8.2276L15.1818 7.2276Z'
      fill='currentColor'
    />
    <path
      d='M15.7275 10.3181C15.828 10.7199 15.5837 11.1271 15.1818 11.2276L11.1818 12.2276C10.78 12.3281 10.3728 12.0837 10.2723 11.6819C10.1719 11.28 10.4162 10.8728 10.818 10.7724L14.818 9.77238C15.2199 9.67192 15.6271 9.91624 15.7275 10.3181Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.1819 1.2724L9 3.22692L16.8181 1.2724C17.284 1.15593 17.75 1.5198 17.75 2V14C17.75 14.3442 17.5158 14.6441 17.1819 14.7276L9.1819 16.7276C9.06247 16.7575 8.93753 16.7575 8.8181 16.7276L0.818098 14.7276C0.484223 14.6441 0.25 14.3442 0.25 14V2C0.25 1.5198 0.716035 1.15593 1.1819 1.2724ZM1.75 2.96059V13.4144L8.25 15.0394L8.25 4.58559L1.75 2.96059ZM16.25 13.4144L9.75 15.0394L9.75 4.58559L16.25 2.96059V13.4144Z'
      fill='currentColor'
    />
  </Svg>
);

Guide18.displayName = 'Guide18';
export default Guide18;
